<template>
  <div class="content-block dx-card responsive-paddings">
    <DxDataGrid id="gridContainer" :ref="gridRefName" :data-source="objectInfoList" :columnAutoWidth="true"
      :show-borders="true" :show-column-lines="true" @row-inserting="onRowInserting" @row-updating="onRowUpdating"
      @row-removing="onRowRemoving" @exporting="onExporting">

      <DxSearchPanel :visible="true" />
      <DxHeaderFilter :visible="true" />
      <DxScrolling mode="infinite" />
      <DxSorting mode="multiple" />
      <DxExport :enabled="true" />
      <DxEditing :allow-updating="true" :allow-adding="false" :allow-deleting="true" mode="popup" />

      <DxColumn type="buttons">
        <DxButton name="edit" />
      </DxColumn>

      <DxColumn data-field="spaceNameId" caption="스페이스" :allowEditing="false" :header-filter="{ allowSearch: true }">
      </DxColumn>

      <DxColumn data-field="mapId" caption="맵" :header-filter="{ allowSearch: true }">
        <DxRequiredRule />
        <DxLookup :data-source="mapList" value-expr="mapId" display-expr="mapNameId" />
      </DxColumn>

      <DxColumn data-field="objectX" caption="X 좌표" data-type="number" :editor-options="{ min: 1, max: 99999 }">
        <DxRequiredRule />
      </DxColumn>

      <DxColumn data-field="objectY" caption="Y 좌표" data-type="number" :editor-options="{ min: 1, max: 99999 }">
        <DxRequiredRule />
      </DxColumn>

      <DxColumn data-field="objectName" caption="오브젝트 이름">
        <DxRequiredRule />
        <DxPatternRule pattern="^.{1,100}$" message="100자 까지 등록 가능" />
      </DxColumn>

      <DxMasterDetail :enabled="true" template="master-detail" />
      <template #master-detail="{ data }">
        <History :master-detail-data="data" :url="`/api/AOBJ/selectHistory`" :keyName="mapId" :columns="historyColumns"
          :key1="data.data.mapId" :key2="data.data.objectX" :key3="data.data.objectY" />
      </template>
    </DxDataGrid>
  </div>
</template>

<script>
import {
  DxDataGrid,
  DxColumn,
  DxScrolling,
  DxSorting,
  DxExport,
  DxHeaderFilter,
  DxEditing,
  DxSearchPanel,
  DxRequiredRule,
  DxPatternRule,
  DxMasterDetail,
  DxLookup
} from "devextreme-vue/data-grid";
import History from "../_common/SIMPLE_HISTORY";
import { userAuth } from "../../utils/syscodedata";
import dsu from "../../utils/dataSourceUtils";
import fn from "../../utils/function";

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxScrolling,
    DxSorting,
    DxExport,
    DxHeaderFilter,
    DxEditing,
    DxSearchPanel,
    DxRequiredRule,
    DxPatternRule,
    DxMasterDetail,
    History,
    DxLookup
  },
  data() {
    return {
      gridRefName: 'grid',
      objectInfoList: [],
      userAuth: userAuth,
      mapList: [],
      historyColumns: [{ dataField: "transTime", caption: "변경 시간" },
      { dataField: "objectName", caption: "오브젝트 이름" },
      { dataField: "userId", caption: "변경 사용자" },
      { dataField: "dml", caption: "Action" }]
    };
  },
  async mounted() {
    await dsu.getAxiosMapList().then(res => { this.mapList = res.data.data });
    await this.refreshData();
  },
  methods: {
    onExporting(e) {
      e.fileName = this.$route.meta.transName;
    },
    refreshData() {
      dsu.getAxiosOBJGet('/api/AOBJ/select').then(res => {
        this.objectInfoList = res.data.data;
      });
    },
    onRowInserting(e) {
      if (!this.validationValue(e.data, true)) {
        e.cancel = true;
      } else {
        this.save(e.data);
      }
    },
    onRowUpdating(e) {
      let data = {};
      let chkKey = false;

      Object.assign(data, e.oldData);
      Object.assign(data, e.newData);

      if ((e.newData.mapId && e.newData.mapId != e.oldData.mapId)
        || (e.newData.objectX && e.newData.objectX != e.oldData.objectX)
        || (e.newData.objectY && e.newData.objectY != e.oldData.objectY)) {
        chkKey = true;
      }

      if (!this.validationValue(data, chkKey)) {
        e.cancel = true;
      } else {
        this.save(data);
      }
    },
    onRowRemoving(e) {
      dsu.getAxiosOBJPost('/api/AOBJ/delete', e.data).then(res => {
        let response = res.data;
        if (response.result == 'SUCCESS') {
          fn.notifySuccess(response.msg);

        } else {
          fn.notifyError(response.msg);
        }
      });
    },
    validationValue(data, chkKey) {
      for (var i = 0; i < this.objectInfoList.length; i++) {
        if (chkKey) {
          if (data.mapId == this.objectInfoList[i].mapId
            && data.objectX == this.objectInfoList[i].objectX
            && data.objectY == this.objectInfoList[i].objectY) {
            fn.notifyError('중복 데이터, Map, X, Y 동일 입력 값 확인필요');
            return false;
          }
        }
      }
      return true;
    },
    save(data) {
      dsu.getAxiosOBJPost('/api/AOBJ/insert', data).then(res => {
        let response = res.data;
        if (response.result == 'SUCCESS') {
          fn.notifySuccess(response.msg);
        } else {
          fn.notifyError(response.msg);
        }
        this.refreshData();
      });
    }
  }
};

</script>

<style scoped>
#gridContainer {
  height: calc(100vh - 220px);
}
</style>